import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { toast } from "sonner";
import { atualizarBot } from "../lib/api";

export default function AbaConfig({ bot, onAtualizado }) {
    const [nome, setNome] = useState(bot.nome);
    const [urlAlvo, setUrlAlvo] = useState(bot.url_alvo);
    const [intervalo, setIntervalo] = useState(bot.intervalo_refresh_ms);
    const [autoRefresh, setAutoRefresh] = useState(bot.auto_refresh_ativo);
    const [salvando, setSalvando] = useState(false);

    const salvar = async () => {
        setSalvando(true);
        try {
            await atualizarBot(bot.id, {
                nome,
                url_alvo: urlAlvo,
                intervalo_refresh_ms: Number(intervalo) || 30000,
                auto_refresh_ativo: autoRefresh,
            });
            toast.success("Configuração salva");
            onAtualizado?.();
        } catch (e) {
            toast.error(e?.response?.data?.erro || "Falha ao salvar");
        } finally {
            setSalvando(false);
        }
    };

    return (
        <div className="bg-zinc-900 border border-zinc-800 rounded-md p-4 space-y-4 max-w-2xl">
            <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wide text-zinc-400">Nome</Label>
                <Input data-testid="input-config-nome" value={nome} onChange={(e) => setNome(e.target.value)}
                    className="bg-zinc-950 border-zinc-800 focus:border-zinc-600" />
            </div>
            <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wide text-zinc-400">URL alvo</Label>
                <Input data-testid="input-config-url" value={urlAlvo} onChange={(e) => setUrlAlvo(e.target.value)}
                    className="bg-zinc-950 border-zinc-800 focus:border-zinc-600 font-mono text-xs" />
            </div>
            <div className="space-y-1.5">
                <Label className="text-xs uppercase tracking-wide text-zinc-400">Intervalo de auto-refresh (ms)</Label>
                <Input data-testid="input-config-intervalo" type="number" min="1000" step="1000"
                    value={intervalo} onChange={(e) => setIntervalo(e.target.value)}
                    className="bg-zinc-950 border-zinc-800 focus:border-zinc-600 font-mono text-xs" />
            </div>
            <div className="flex items-center gap-2">
                <Switch checked={autoRefresh} onCheckedChange={setAutoRefresh} data-testid="switch-auto-refresh" />
                <Label className="text-xs text-zinc-300">Auto-refresh ativo</Label>
            </div>
            <Button data-testid="btn-salvar-config" onClick={salvar} disabled={salvando}
                className="bg-white text-zinc-950 hover:bg-zinc-200">Salvar configurações</Button>
        </div>
    );
}
